import { Controller } from "@hotwired/stimulus"

/**
 * Consent Toggle — auto-saves one boolean setting (a consent level, or a notification preference field) the
 * instant the switch is flipped (no separate Save
 * click). Fixes the "flip → refresh → reverts" trap, where an unsaved flip was silently lost. Posts ONLY
 * this level (the other is left untouched by ConsentsController#apply_consent), and reverts the switch on
 * failure so the UI never shows a state we didn't actually persist.
 */
export default class extends Controller {
  static values = { url: String, level: String }

  async toggle(event) {
    const input = event.target
    const checked = input.checked
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const res = await fetch(this.urlValue, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": token },
        body: JSON.stringify({ [this.levelValue]: checked ? "1" : "0" })
      })
      if (!res.ok) input.checked = !checked // server rejected → revert the switch
    } catch (_e) {
      input.checked = !checked // network error → revert; never lie about the persisted state
    }
  }
}
